import { useAxios } from '@healthblocks-io/core'
import useSWR from 'swr'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'
import { BadgeService } from '@/modules/shared/services/badgeService'

import type { CareplanActivity } from '@healthblocks-io/core'
import type { Content } from '../types/content.type'

/**
 * Fetches the content from the API
 */
export function useContent() {
  const axios = useAxios()

  const fetcher = async () => {
    const { data } = await axios.get<Content[]>('/cms/content')
    return data
  }

  return useSWR('content', fetcher, { errorRetryCount: 3 })
}

export function useContentById(id?: string, includeDrafts?: boolean) {
  const axios = useAxios()

  const fetcher = async () => {
    const { data } = await axios.get<Content>(`/cms/content/${id}`, {
      params: { draft: includeDrafts },
    })
    return data
  }

  return useSWR(`content_${id}_${includeDrafts}`, fetcher, {
    errorRetryCount: 3,
  })
}

export function useUpdateContentItem() {
  const axios = useAxios()

  const markContentItemAsRead = async (id: number) => {
    BadgeService.decrementBadgeCount()
    return axios.patch<CareplanActivity>('/careplan-activity/' + id, {
      status: 'completed',
    })
  }

  return {
    markContentItemAsRead: useAxiosAsync(markContentItemAsRead),
  }
}
